import React from 'react';
import { Button } from 'react-bootstrap';

import Table from '../../../../../facturotopia/table/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RetencionesLocalesList = ({ data, onDelete, onEdit }) => {

  const handleEdit = (item) => {
    onEdit(item);
  }

  const handleDelete = (item) => {
    onDelete(item);
  }

  return (
    <>
      <Table
        columns={ columns(handleEdit, handleDelete) }
        rowKey={ 'id' }
        data={ data }
      >
      </Table>
    </>
  )
}

const columns = (handleEdit, handleDelete) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={ handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['far', 'edit'] } />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={ handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['fas', 'trash'] } />
          </Button>
        </>
      );
    }
  },
  {
    align: 'center',
    key: 'ImpLocRetenido',
    title: 'Imp. Loc. Retenido',
    dataIndex: 'ImpLocRetenido',
  },
  {
    align: 'center',
    key: 'TasadeRetencion',
    title: 'Tasa de Retencion',
    dataIndex: 'TasadeRetencion',
  },
  {
    align: 'center',
    key: 'Importe',
    title: 'Importe',
    dataIndex: 'Importe',
  },
];

export default RetencionesLocalesList;